import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import './Menu.css';

const API_URL = process.env.REACT_APP_API_URL || 'https://moyobed.pro';

function Profile({ user, darkMode, toggleTheme }) {
  const [lastName, setLastName] = useState(user.last_name || '');
  const [initials, setInitials] = useState(user.initials || '');
  const [phone, setPhone] = useState(user.phone || '');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  // Смена PIN
  const [showPinChange, setShowPinChange] = useState(false);
  const [pinForm, setPinForm] = useState({ old_pin: '', new_pin: '', confirm_pin: '' });
  const [pinError, setPinError] = useState('');
  const [pinSuccess, setPinSuccess] = useState('');
  const [pinLoading, setPinLoading] = useState(false);

  const navigate = useNavigate();

  const handleSaveProfile = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    setLoading(true);

    try {
      const formData = new FormData();
      formData.append('employee_id', user.id);
      formData.append('last_name', lastName);
      formData.append('initials', initials);

      await axios.post(`${API_URL}/api/auth/profile`, formData);
      
      // Обновляем данные в localStorage
      const updatedUser = { 
        ...user, 
        last_name: lastName, 
        initials: initials,
        full_name: `${lastName} ${initials}`.trim()
      };
      sessionStorage.setItem('moyobed_user', JSON.stringify(updatedUser));
      
      setSuccess('✅ Профиль обновлён!');
    } catch (err) {
      setError(err.response?.data?.detail || 'Ошибка сохранения');
    } finally {
      setLoading(false);
    }
  };

  const handleChangePin = async (e) => {
    e.preventDefault();
    setPinError('');
    setPinSuccess('');
    
    if (pinForm.new_pin !== pinForm.confirm_pin) {
      setPinError('PIN-коды не совпадают');
      return;
    }
    if (pinForm.new_pin.length !== 4 || !/^\d{4}$/.test(pinForm.new_pin)) {
      setPinError('PIN должен быть 4 цифры');
      return;
    }

    setPinLoading(true);
    try {
      const formData = new FormData();
      formData.append('employee_id', user.id);
      formData.append('old_pin', pinForm.old_pin);
      formData.append('new_pin', pinForm.new_pin);
      
      await axios.post(`${API_URL}/api/auth/change-pin`, formData);
      setPinSuccess('✅ PIN изменён!');
      setPinForm({ old_pin: '', new_pin: '', confirm_pin: '' });
      
      setTimeout(() => {
        setShowPinChange(false);
        setPinSuccess('');
      }, 2000);
    } catch (err) {
      setPinError(err.response?.data?.detail || 'Ошибка смены PIN');
    } finally {
      setPinLoading(false);
    }
  };

  const handleLogout = () => {
    sessionStorage.removeItem('moyobed_user');
    window.location.href = '/';
  };

  return (
    <div className="page menu-page">
      <header className="menu-header">
        <div className="header-left">
          <h1 className="page-title">👤 Профиль</h1>
        </div>
        <div className="header-right">
          <button className="btn btn-sm btn-outline" onClick={toggleTheme}>
            {darkMode ? '☀️' : '🌙'}
          </button>
          <button className="btn btn-sm" onClick={() => navigate('/menu')}>🍽️ Меню</button>
          <button className="btn btn-sm" onClick={() => navigate('/cart')}>🛒 Корзина</button>
          <button className="btn btn-sm btn-outline" onClick={handleLogout}>🚪 Выйти</button>
        </div>
      </header>

      <div className="card" style={{ maxWidth: 500, margin: '0 auto' }}>
        <h2>📝 Мои данные</h2>
        
        <form onSubmit={handleSaveProfile} style={{ marginTop: 16 }}>
          <div className="form-group">
            <label>Фамилия</label>
            <input
              className="input"
              value={lastName}
              onChange={e => setLastName(e.target.value)}
              placeholder="Фамилия"
              required
            />
          </div>
          
          <div className="form-group">
            <label>Инициалы</label>
            <input
              className="input"
              value={initials}
              onChange={e => setInitials(e.target.value.toUpperCase().replace(/[^А-ЯЁ]/g, ''))}
              placeholder="И.О."
            />
          </div>

          <div className="form-group">
            <label>Телефон</label>
            <input
              className="input"
              value={phone}
              disabled
              style={{ opacity: 0.7 }}
            />
            <small style={{ color: 'var(--text-light)' }}>Телефон может изменить только администратор</small>
          </div>

          {user.branch_name && (
            <div className="form-group">
              <label>Филиал</label>
              <input
                className="input"
                value={user.branch_name}
                disabled
                style={{ opacity: 0.7 }}
              />
            </div>
          )}

          {error && <div className="error-message">{error}</div>}
          {success && <div className="success-message">{success}</div>}

          <button type="submit" className="btn" disabled={loading} style={{ width: '100%', marginTop: 12 }}>
            {loading ? '⏳ Сохранение...' : '💾 Сохранить'}
          </button>
        </form>

        <hr style={{ margin: '20px 0', border: 'none', borderTop: '1px solid var(--border)' }} />

        {!showPinChange ? (
          <button className="btn btn-outline" onClick={() => setShowPinChange(true)} style={{ width: '100%' }}>
            🔑 Сменить PIN-код
          </button>
        ) : (
          <div>
            <h3>🔑 Смена PIN-кода</h3>
            <form onSubmit={handleChangePin}>
              <input
                type="password"
                className="input"
                placeholder="Текущий PIN"
                value={pinForm.old_pin}
                onChange={e => setPinForm({...pinForm, old_pin: e.target.value.replace(/\D/g, '').slice(0, 4)})}
                maxLength={4}
                required
                disabled={pinLoading}
              />
              <input
                type="password"
                className="input"
                placeholder="Новый PIN (4 цифры)"
                value={pinForm.new_pin}
                onChange={e => setPinForm({...pinForm, new_pin: e.target.value.replace(/\D/g, '').slice(0, 4)})}
                maxLength={4}
                required
                disabled={pinLoading}
                style={{ marginTop: 8 }}
              />
              <input
                type="password"
                className="input"
                placeholder="Подтвердите PIN"
                value={pinForm.confirm_pin}
                onChange={e => setPinForm({...pinForm, confirm_pin: e.target.value.replace(/\D/g, '').slice(0, 4)})}
                maxLength={4}
                required
                disabled={pinLoading}
                style={{ marginTop: 8 }}
              />
              {pinError && <div className="error-message" style={{ marginTop: 8 }}>{pinError}</div>}
              {pinSuccess && <div className="success-message" style={{ marginTop: 8 }}>{pinSuccess}</div>}
              <div style={{ display: 'flex', gap: 8, marginTop: 12 }}>
                <button type="submit" className="btn" disabled={pinLoading}>
                  {pinLoading ? '⏳' : '💾 Сменить'}
                </button>
                <button type="button" className="btn btn-outline" onClick={() => setShowPinChange(false)} disabled={pinLoading}>
                  Отмена
                </button>
              </div>
            </form>
          </div>
        )}
      </div>

      <nav className="bottom-nav">
        <button className="btn" onClick={() => navigate('/menu')}>🍽️ К меню</button>
        <button className="btn" onClick={() => navigate('/cart')}>🛒 Корзина</button>
      </nav>
    </div>
  );
}

export default Profile;
